/**
 * DPRに関するユーティリティクラス
 */
export default class DPR {
    /**
     * 1 < DPR < 1.5なら値にDPRを掛ける
     */
    static mul(v) {
        if(1 < window.devicePixelRatio && window.devicePixelRatio < 1.5) {
            return v * window.devicePixelRatio;
        }
        return v;
    }

    /**
     * DPR 1 < DPR < 1.5なら値をDPRで割る
     */
    static div(v) {
        if(1 < window.devicePixelRatio && window.devicePixelRatio < 1.5) {
            return v / window.devicePixelRatio;
        }
        return v;
    }
}
